<template>
    <div class="pb-4">
        <v-text-field
            :label="label"
            v-model="search"
			outlined
			dense
        ></v-text-field>

        <v-slide-x-transition group>
            <template v-show="search != ''">
                <v-chip small v-for="(item, i) in filteredItems" :key="i" @click="handleInput(item)">{{ item }}</v-chip>
            </template>
        </v-slide-x-transition>
        <v-subheader v-if="selectedItems && selectedItems.length > 0" class="pl-0">Selezionati:</v-subheader>
        <v-chip small v-for="(item, i) in selectedItems" :key="i" @click:close="selectedItems.splice(i, 1)" close>{{ item }}</v-chip>
    </div>
</template>

<script>
export default {
	name: 'duplicates-select',
	props: {
		label: String,
		items: Array,
		value: Array
	},

	data: () => ({
		search: '',
		selectedItems: []
	}),

	// watch: {
	//     search(newValue, oldValue) {
	//         if(this.search != '') {

	//         }
	//     }
	// },

	methods: {
		handleInput(item) {
			this.selectedItems.push(item)
			this.$emit('input', this.selectedItems)
		}
	},

	computed: {
		filteredItems() {
			const search = this.search.toLowerCase().trim()
			if (!search) return this.items
            
			return this.items.filter(k => k ? k.toLowerCase().indexOf(search) > -1 : false)
		},
	},

	created() {
		if(this.value != null) {
			this.selectedItems = this.value
		}
	}


}
</script>

<style>

</style>
